import { render, staticRenderFns } from "./account-adjustment-dialog.vue?vue&type=template&id=52585bd2&scoped=true"
import script from "./account-adjustment-dialog.vue?vue&type=script&lang=js"
export * from "./account-adjustment-dialog.vue?vue&type=script&lang=js"
import style0 from "./account-adjustment-dialog.vue?vue&type=style&index=0&id=52585bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52585bd2",
  null
  
)

export default component.exports